import React from 'react';
import styled from 'styled-components';
import type { Issue, AppData } from '../types';
import Card from './common/Card';
import { Icon } from 'bench-internal-theme';

type ClosedCustomerQuestionsCardProps = {
  appData: AppData;
};

const Container = styled.div`
  max-height: 512px;
  overflow-y: auto;
  padding: 0;
`;

const Question = styled.div`
  padding: 20px;
  border-top: 2px solid #e4e5e7;
  &:first-of-type {
    border: none;
  }
  word-wrap: break-word;
`;

const IssueName = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`;

const ClosedCustomerQuestionsCard = ({ appData }: ClosedCustomerQuestionsCardProps) => {
  return (
    <Card
      header={'Closed Customer Questions'}
      headerIcon={<Icon icon={'circleCheck'} />}
      defaultExpanded={false}
    >
      <Container>
        {appData.resolvedIssues?.map((issue: Issue, i: number) => (
          <Question key={i}>
            <IssueName>{issue.issueTopic}</IssueName>
            <div>{issue.description}</div>
          </Question>
        ))}
      </Container>
    </Card>
  );
};

export default ClosedCustomerQuestionsCard;
